import React, { useState } from "react";

import "./styles.css";
import ProgressBarComponent from "./progressBar/ProgressBar";
import PersonalData from "./steps/PersonalData.js";
import SelectLicensePlate from "./steps/SelectLicensePlate.js";
import VehicleData from "./steps/VehicleData.js";
import Confirmation from "./steps/Confirmation.js";
import { useSignupForm } from "./useSignupForm";
import { toastr } from "react-redux-toastr";
import { onlyNumbers } from "../../utils/normalize";
import UserRepository from "../../repositories/UserRepository.js";
import { ipService } from "../../services/ipService.js";
import { openClientSession } from "../../services/sessionService";
import AuthLayout from "../../components/AuthLayout";

const FormSignUp = ({ history }) => {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);

  const form = useSignupForm({});

  const nextPage = () => setStep(step + 1);
  const previousPage = () => setStep(step - 1);

  const onSubmit = async () => {
    setLoading(true);
    try {
      const {
        email,
        password,
        name,
        cpfCnpj,
        phone,
        licensePlate,
        model,
        brand,
        termId,
      } = form.values;
      const userIp = await ipService.getIpAddress();

      const data = await UserRepository.createUser({
        name,
        email,
        password,
        cpfCnpj: onlyNumbers(cpfCnpj),
        phone: onlyNumbers(phone),
        licensePlate: licensePlate.replace("-", ""),
        brand: brand.label,
        model: model.label,
        termId,
        ip: userIp,
      });
      openClientSession(data);
      localStorage.setItem("USER_CONFIRMED", true);

      toastr.success("Cadastro realizado com sucesso");
      setTimeout(() => history.push("/client/dashboard"), 1000);
    } catch (err) {
      console.error(err);
      toastr.warning(
        "Ocorreu um erro ao salvar o usuário. Por favor, tente novamente"
      );
    } finally {
      setLoading(false);
    }
  };

  const formProps = {
    ...form,
    history,
    onSubmit,
    loading,
    setLoading,
    nextPage,
    previousPage,
    selectHeight: "50px",
  };

  return (
    <AuthLayout
      className="signup-page"
      eyebrow="Minha garagem"
      title="Seu veículo tem uma história."
      highlight="Vamos organizá-la."
    >
      {/* Os passos avancam por botao; o submit so impede o Enter de recarregar a pagina. */}
      <form className="signup-form" onSubmit={(event) => event.preventDefault()} noValidate>
        <ProgressBarComponent step={step} />
        {step === 1 && <PersonalData {...formProps} />}
        {step === 2 && <SelectLicensePlate {...formProps} />}
        {step === 3 && <VehicleData {...formProps} />}
        {step === 4 && <Confirmation {...formProps} />}
      </form>
    </AuthLayout>
  );
};

export default FormSignUp;
